<template>
  <div class="info" :class="size" :style="styles">
    <img
      @load="resolveAsset($event)"
      v-show="icon"
      :src="icon"
      alt=""
      class="info__icon"
    />
    <span class="info__text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    size: {
      type: String,
      default: 'md',
    },
    icon: {
      type: String,
      default: () => require('@/assets/images/iconos/info.svg'),
    },
    text: {
      type: String,
      default: 'Texto por definir',
    },
    color: {
      type: String,
      default: 'black',
    },
    background: {
      type: String,
      default: null,
    },
  },
  computed: {
    styles() {
      return {
        padding: this.background ? '5px 10px' : '0px',
        borderRadius: this.background ? '5px' : '0px',
        color: this.color,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  width: auto;
  background-color: v-bind(background);
  &__icon {
    opacity: 0;
    height: 20px;
    width: 20px;
    object-fit: contain;
    -webkit-transition: 0.35s ease-in-out opacity;
    -moz-transition: 0.35s ease-in-out opacity;
    -ms-transition: 0.35s ease-in-out opacity;
    -o-transition: 0.35s ease-in-out opacity;
    transition: 0.35s ease-in-out opacity;
  }
  &__text {
    margin-left: 5px;
    font-size: 15px;
  }
  &.sm {
    & .info {
      &__icon {
        height: 15px;
        width: 15px;
      }
      &__text {
        font-size: 13px;
      }
    }
  }
  &.lg {
    & .info {
      &__icon {
        height: 25px;
        width: 25px;
      }
      &__text {
        font-size: 17px;
      }
    }
  }
}
</style>
